import IRootPageLink, { IRootPageLinkTags } from '@/types/IRootPageLink';
import { yupResolver } from '@hookform/resolvers/yup';
import { UseFormReturn, useForm } from 'react-hook-form';
import { StringSchema, lazy, object, string } from 'yup';

const schema = object().shape({
	link: string().required(),
	name: string().required(),
	description: string().optional(),
	imageUrl: string().optional(),
	tags: lazy((value: IRootPageLinkTags) => {
		if (!value) {
			return object<IRootPageLinkTags>().optional();
		}

		const shape: Record<string, StringSchema> = {};

		Object.keys(value).forEach((key) => {
			shape[key] = string().optional();
		});
		return object<IRootPageLinkTags>().shape(shape).optional();
	}).optional(),
});

interface IArgs {
	link: IRootPageLink;
}

export function useRootPageLinkForm(args: IArgs) {
	const form = useForm({
		defaultValues: {
			link: args.link.link,
			name: args.link.name,
			description: args.link.description || '',
			imageUrl: args.link.imageUrl || '',
			tags: args.link.tags,
		},

		resolver: yupResolver(schema),
		// Yup does not support IRootPageLinkTags so we need to cast it.
	}) as UseFormReturn<IRootPageLink>;

	return { form };
}
